import(/* webpackMode: "eager" */ "/codebuild/output/src3033254012/src/apps/fanychance/src/app/error.tsx");
